export const TOURPRODUCT_LOADING = 'REDUX_SAGA_TOURPRODUCT_LOADING';
export const GET_TOURPRODUCT_DATA_SUCCESS = 'REDUX_SAGA_GET_TOURPRODUCT_DATA_SUCCESS';
export const GET_TOURPRODUCT_DATA_ERROR = 'REDUX_SAGA_GET_TOURPRODUCT_DATA_ERROR';

export const actionGetTourProduct = (dispatch,tourProductID,priceDate,CostRateID) => {
    dispatch({ 

        type: TOURPRODUCT_LOADING , 
        tourProductID : tourProductID, 
        priceDate : priceDate, 
        CostRateID : CostRateID 
    })
};


